<script setup lang="ts">
  defineOptions({
    name: 'ChatPanelHeader',
  })

  import { computed } from 'vue'

  import { useI18n } from 'vue-i18n'

  import { ArrowLeftIcon, Expand01Icon, Minimize01Icon, XCloseIcon } from '@gohighlevel/ghl-icons/24/outline'

  import CPButton from '@ui/components/CPButton.vue'

  import CPText from '@ui/components/CPText.vue'

  const props = defineProps({
    title: {
      type: String,
      default: undefined,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    showExpandButton: {
      type: Boolean,
      default: true,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits<{
    toggleExpand: []
    close: []
    back: []
  }>()

  const { t } = useI18n()

  // Computed title with translation fallback
  const displayTitle = computed(() => props.title ?? t('chats.header.title'))

  // Computed button titles
  const backTitle = computed(() => t('chats.actions.back'))

  const expandTitle = computed(() => (props.isExpanded ? t('chats.actions.minimize') : t('chats.actions.expand')))

  const closeTitle = computed(() => t('chats.actions.close'))
</script>

<template>
  <div id="chat-panel-header" class="flex items-center justify-between border-b border-default bg-background px-4 py-3">
    <div class="flex items-center gap-2">
      <!-- Back button -->
      <CPButton
        v-if="showBackButton"
        id="chat-panel-back"
        type="text"
        size="sm"
        :title="backTitle"
        class="h-6 w-6 p-0"
        @click="emit('back')"
      >
        <ArrowLeftIcon class="h-4 w-4 text-secondary" />
      </CPButton>

      <CPText id="chat-panel-title" size="lg" weight="semibold" class="text-body">
        {{ displayTitle }}
      </CPText>
    </div>

    <div class="flex items-center gap-1">
      <CPButton
        v-if="showExpandButton"
        id="chat-panel-toggle-expand"
        type="text"
        size="sm"
        :title="expandTitle"
        class="h-6 w-6 p-0"
        @click="emit('toggleExpand')"
      >
        <Minimize01Icon v-if="isExpanded" class="h-4 w-4 text-secondary" />
        <Expand01Icon v-else class="h-4 w-4 text-secondary" />
      </CPButton>
      <CPButton
        v-if="showCloseButton"
        id="chat-panel-close"
        type="text"
        size="sm"
        :title="closeTitle"
        class="h-6 w-6 p-0"
        @click="emit('close')"
      >
        <XCloseIcon class="h-4 w-4 text-secondary" />
      </CPButton>
    </div>
  </div>
</template>
